// extracted by mini-css-extract-plugin
export var bubble = "_18-0";
export var container = "_18-f";
export var contrastBorder = "_18-g";
export var greyOut = "_18-2";
export var initialsColor0 = "_18-3";
export var initialsColor1 = "_18-4";
export var initialsColor10 = "_18-d";
export var initialsColor11 = "_18-e";
export var initialsColor2 = "_18-5";
export var initialsColor3 = "_18-6";
export var initialsColor4 = "_18-7";
export var initialsColor5 = "_18-8";
export var initialsColor6 = "_18-9";
export var initialsColor7 = "_18-a";
export var initialsColor8 = "_18-b";
export var initialsColor9 = "_18-c";
export var initialsWrapper = "_18-1";
export var large = "_18-l";
export var medium = "_18-k";
export var mediumSmall = "_18-j";
export var mediumSmallMedium = "_18-o";
export var micro = "_18-h";
export var small = "_18-i";
export var tiny = "_18-n";
export var xTiny = "_18-m";